<template>
    <b-modal
        :hide-footer="true"
        :title="$t('Cadastrar Gestante')"
        centered
        size="xl"
        id="cadastrar-gestante"
    >
        <form @submit.prevent="submit" ref="addItem">
            <div class="row">
                <form-radio
                label="Selecione como será contabilizado o tempo da gravidez"
                    name="is_mes"
                    v-model="is_mes"
                    :itens="gestacao_tipo_tempo"
                />
                <form-select
                    v-model="gestante"
                    grid="6"
                    label="Pessoa"
                    :itens="pessoas"
                    :required="true"
                />
                <form-input
                    type="number"
                    v-model="meses_gestacao"
                    grid="6"
                    min="1"
                    max="9"
                    label="Quantos meses de gestação?"
                    v-if="is_mes == 1"
                />
                <form-input
                    v-else
                    type="number"
                    v-model="semanas_gestacao"
                    grid="6"
                    min="1"
                    max="45"
                    label="Quantas semanas de gestação?"
                />
                <form-select
                    v-model="inicio_pre_natal"
                    grid="6"
                    label="Iniciou o pré-natal?"
                    :itens="$root.arrays.pergunta"
                    :required="true"
                />

                <form-calendar
                    v-model="dataAdd"
                    grid="6"
                    label="Data da anotação"
                    :required="true"
                    :max-date="dataNow"
                />

                <form-textarea
                    v-model="observacao"
                    placeholder="Digite aqui..."
                    grid="12"
                    rows="3"
                    max-rows="6"
                    label="Observação"
                />
            </div>

            <div class="row pt-4 px-2 d-flex justify-content-end">
                <button
                    type="submit"
                    class="btn btn-success btn-add-gestante"
                    data-style="zoom-in"
                >
                    <i class="mdi mdi-content-save"></i>
                    Salvar
                </button>
            </div>
        </form>
    </b-modal>
</template>
<script>
export default {
    props: ["item"],
    data() {
        return {
            gestante: "",
            is_mes: 1,
            semanas_gestacao: "",
            meses_gestacao: "",
            inicio_pre_natal: "",
            dataAdd: moment().format("YYYY/MM/DD"),
            dataNow: moment().format("YYYY/MM/DD"),
            observacao: "",
            gestacao_tipo_tempo:[
                {id:1, value:'Meses'},
                {id:2, value:'Semanas'}
            ]
        };
    },
    computed: {
        pessoas() {
            const pessoas = this.item.familiares;

            const result = pessoas.filter(
                (pessoa) => pessoa.sexo == "2" && pessoa.idade > 7
            );

            const map = result.map((elem) => ({
                id: elem.id,
                value: elem.nome_completo + " <b>" + elem.idade + " ano(s)</b>",
            }));
            return map;
        },
    },
    methods: {
        submit() {
            let ladda = Ladda.create(
                document.querySelector(".btn-add-gestante")
            );
            ladda.start();
            this.data_anotacao = this.$options.filters.formatDateYMD(
                this.dataAdd
            );
            axios
                .post("api/dashboard/familias/gestante", {
                    familia_id: this.item.id,
                    usuario_id: this.gestante,
                    is_mes: this.is_mes,
                    semanas_gestacao: this.semanas_gestacao,
                    meses_gestacao: this.meses_gestacao,
                    inicio_pre_natal: this.inicio_pre_natal,
                    data_anotacao: this.data_anotacao,
                    observacao: this.observacao,
                })
                .then((response) => {
                    this.$snack.success({
                        button: false,
                        text: "Gestante cadastrado com sucesso.",
                    });
                    this.item.gestantes = response.data;
                    this.$bvModal.hide("cadastrar-gestante");

                    this.gestante = "";
                    this.meses_gestacao = "";
                    this.inicio_pre_natal = "";
                    this.data_anotacao = "";
                    this.observacao = "";
                    ladda.stop();
                })
                .catch(() => ladda.stop());
        },
        paginate(array, page_size, page_number) {
            // human-readable page numbers usually start with 1, so we reduce 1 in the first argument
            return array.slice(
                (page_number - 1) * page_size,
                page_number * page_size
            );
        },
    },
};
</script>
